export default {
  props: {
    articleId: {
      type   : String,
      default: ''
    }
  },
  computed: {
    id () {
      return this.articleId || this.$route.params.id
    }
  }
}
